import _ from 'lodash'
import {
  SET_POSITION_LIST,
  SET_SELECTED_POSITION,
  SET_SELECTED_POSITION_NAME,
  SET_ABILITY_ADD_DRIVER,
  SET_ABILITY_EDIT_DRIVER,
  SET_ABILITY_DRIVER_SERVICE,
  SET_ABILITY_DRIVER_MONITOR,
  SET_ABILITY_DRIVER_TRAJECTORY,
  SET_ABILITY_DRIVER_MESSAGE,
  SET_ABILITY_TRANSACTION,
  SET_ABILITY_TRANSACTION_STATISTICS,
  SET_ABILITY_CUSTOMER,
  SET_ABILITY_STORE,
  SET_ABILITY_LANDMARK,
  SET_ABILITY_RESERVATION,
  SET_ABILITY_DISPATCH_AREA,
  SET_ABILITY_SCHEDULED_AREA,
  SET_ABILITY_SCHEDULED_BOARD,
  SET_ABILITY_MOBILE_PAYMENT,
  SET_ABILITY_USER_MANAGEMENT,
  SET_ABILITY_USER_BEHAVIOR,
  SET_ABILITY_POSITION_MANAGEMENT,
  SET_ABILITY_TRANSACTION_RECORD,
  SET_ABILITY_CALL_CAR,
  SET_ABILITY_SAVE_HAIL_BILL,
  SET_ABILITY_SAVE_RESERVATION,
  SET_ABILITY_ANNOUNCEMENT,
  SET_ABILITY_USER_DELETION,
} from './mutation-types'

export default {
  [SET_POSITION_LIST](state, positionList) {
    if (positionList === undefined) return
    state.positionList = positionList
  },
  [SET_SELECTED_POSITION](state, positionObj) {
    if (positionObj === undefined) return
    state.selectedPosition = positionObj
  },
  [SET_SELECTED_POSITION_NAME](state, name) {
    state.selectedPosition.positionName = name
    console.log(state.selectedPosition.positionName)
  },
  [SET_ABILITY_ADD_DRIVER](state, ability) {
    state.selectedPosition.addDriver = ability
  },
  [SET_ABILITY_ANNOUNCEMENT](state, ability) {
    state.selectedPosition.announcement = ability
  },
  [SET_ABILITY_CALL_CAR](state, ability) {
    state.selectedPosition.callCar = ability
  },
  [SET_ABILITY_CUSTOMER](state, ability) {
    state.selectedPosition.customer = ability
  },
  [SET_ABILITY_DISPATCH_AREA](state, ability) {
    state.selectedPosition.dispatchArea = ability
  },
  [SET_ABILITY_DRIVER_MESSAGE](state, ability) {
    state.selectedPosition.driverMessage = ability
  },
  [SET_ABILITY_DRIVER_MONITOR](state, ability) {
    state.selectedPosition.driverMonitor = ability
  },
  [SET_ABILITY_DRIVER_SERVICE](state, ability) {
    state.selectedPosition.defaultDriverService = ability
  },
  [SET_ABILITY_DRIVER_TRAJECTORY](state, ability) {
    state.selectedPosition.driverTrajectory = ability
  },
  [SET_ABILITY_EDIT_DRIVER](state, ability) {
    state.selectedPosition.editDriver = ability
  },
  [SET_ABILITY_LANDMARK](state, ability) {
    state.selectedPosition.landmark = ability
  },
  [SET_ABILITY_MOBILE_PAYMENT](state, ability) {
    state.selectedPosition.mobilePayment = ability
  },
  [SET_ABILITY_POSITION_MANAGEMENT](state, ability) {
    state.selectedPosition.positionManagement = ability
  },
  [SET_ABILITY_RESERVATION](state, ability) {
    state.selectedPosition.reservation = ability
  },
  [SET_ABILITY_SAVE_HAIL_BILL](state, ability) {
    state.selectedPosition.saveHailBill = ability
  },
  [SET_ABILITY_SAVE_RESERVATION](state, ability) {
    state.selectedPosition.saveReservation = ability
  },
  [SET_ABILITY_SCHEDULED_AREA](state, ability) {
    state.selectedPosition.scheduledArea = ability
  },
  [SET_ABILITY_SCHEDULED_BOARD](state, ability) {
    state.selectedPosition.scheduledBoard = ability
  },
  [SET_ABILITY_STORE](state, ability) {
    state.selectedPosition.store = ability
  },
  [SET_ABILITY_TRANSACTION_RECORD](state, ability) {
    state.selectedPosition.instanceTransactionRecord = ability
  },
  [SET_ABILITY_TRANSACTION_STATISTICS](state, ability) {
    state.selectedPosition.transactionStatistics = ability
  },
  [SET_ABILITY_TRANSACTION](state, ability) {
    state.selectedPosition.transaction = ability
  },
  [SET_ABILITY_USER_BEHAVIOR](state, ability) {
    state.selectedPosition.userBehavior = ability
  },
  [SET_ABILITY_USER_DELETION](state, ability) {
    state.selectedPosition.userDeletion = ability
  },
  [SET_ABILITY_USER_MANAGEMENT](state, ability) {
    state.selectedPosition.userManagement = ability
  },
}



// WEBPACK FOOTER //
// ./src/store/positionStore/mutations.js